import React, { Fragment, useState, useEffect } from 'react'
import { Form, Input, Button, Select, Layout, Row, Col, Card, Breadcrumb, Typography, Upload, List, message, Avatar } from 'antd';
import { Link, Redirect } from 'react-router-dom';
import { UploadOutlined, DeleteOutlined } from '@ant-design/icons';
import Axios from 'axios';
import { url } from '../../config/global';
import dummyImg from '../../assets/img/dummy_img.jpg'

const { Title } = Typography
const { Option } = Select;
const { Content } = Layout
const {TextArea} = Input

const layout = {
    labelCol: {
        lg: 8,
        md: 10
    },
    wrapperCol: {
        lg: 8,
        md: 14
    },
}
const tailLayout = {
    wrapperCol: {
        offset: 8,
        span: 16,
    },
}

function ViewPriority(props) {

    const [data, setData] = useState({
        name: '',
        priority_id: '',
        priority_level: ''
    })

    const [error, setError] = useState(null)
    const [loading, setLoading] = useState(false)
   
    useEffect(() => {
        getDetail()

    }, [props.match.params.id])

    const getDetail =  () => {
        Axios.get(`${url}/priority/${props.match.params.id}`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`
            }
        }).then(res => {
                // console.log(res)
             setData({
                name: res.data.data.name,
                priority_id: res.data.data.priority_id,
                priority_level: res.data.data.priority_level,
            })
        }).catch(err => {
            if (err.response) {
                message.error(err.response.data.message)
                if (err.response.status == 401) {
                    localStorage.removeItem('token')
                }
            }
        })
    }

    const dataview = [
        {
            title: ('Name'),
            description: data && data.name
        },
    ];

    const dataview2 = [
        {
            title: ('Level'),
            description: data && data.priority_level
        }
    ];

    if (!localStorage.getItem('token')) {
        return <Redirect to="/login" />
    }

    return (
        <Fragment>
            <Row>
                <Col xs={24}>
                    <Card>
                        <Title level={4}>View Priority</Title>
                        <Row type="flex" justify="left">
                            <Breadcrumb>
                                <Breadcrumb.Item>
                                    <Link to="/priority">Priority</Link>
                                </Breadcrumb.Item>
                                <Breadcrumb.Item>View Priority</Breadcrumb.Item>
                            </Breadcrumb>
                        </Row>
                    </Card>
                </Col>
            </Row>
            <Content className="content">
                <Row>
                <Col xs={24}>
                        <Card className="body-data">
                            <Row type="flex" gutter={40} className="pr-25 pl-25 mb-25">
                                <Col sm={24} md={12}>
                                    <List
                                        itemLayout="horizontal"
                                        dataSource={dataview}
                                        renderItem={item => (
                                            <List.Item>
                                                <List.Item.Meta
                                                title={<strong>{item.title}</strong>}
                                                description={item.description ? item.description : '-'}
                                                />
                                            </List.Item>
                                        )}
                                    />
                                </Col>
                                <Col sm={24} md={12}>
                                    <List
                                        itemLayout="horizontal"
                                        dataSource={dataview2}
                                        renderItem={item => (
                                            <List.Item>
                                                <List.Item.Meta
                                                title={<strong>{item.title}</strong>}
                                                description={item.description ? item.description : '-'}
                                                />
                                            </List.Item>
                                        )}
                                    />
                                </Col>
                            </Row>
                        </Card>
                    </Col>
                </Row>
            </Content>
        </Fragment>
    )
}

export default ViewPriority